exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon {\n  width: 1em; height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.v-modal {\n  background: #fff;\n}\n.el-dialog {\n  box-shadow: none;\n}\n.el-dialog__body {\n  padding-top: 0;\n}\n.edit-panel .CodeMirror {\n  height: calc(100vh - 66px);\n}", ""]);

// exports
